import React from "react";


export const backCaret = (
  <svg
    width="6"
    height="11"
    viewBox="0 0 6 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.76857 10.7761L0.146076 5.87336C-0.048692 5.66698 -0.048692 5.33356 0.146076 5.12664L4.76857 0.223935C5.04973 -0.0746449 5.50719 -0.0746449 5.78885 0.223935C6.07002 0.522514 6.07002 1.0071 5.78885 1.30568L1.83456 5.50027L5.78885 9.69378C6.07002 9.9929 6.07002 10.4775 5.78885 10.7761C5.50719 11.0746 5.04973 11.0746 4.76857 10.7761Z"
      fill="#57bd38"
    />
  </svg>
); 

export const previousIcon = (
  <svg
    width="9"
    height="12"
    viewBox="0 0 9 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.26306 1.41L6.84915 0L0.83252 6L6.84915 12L8.26306 10.59L3.67037 6L8.26306 1.41Z"
      fill="#57bd38"
    />
  </svg>
);

export const nextIcon = (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.491331 1.41L1.90524 0L7.92188 6L1.90524 12L0.491331 10.59L5.08403 6L0.491331 1.41Z"
      fill="#57bd38"
    />
  </svg>
);
export const dropdownCaret = (
  <svg
    width="14"
    height="7"
    viewBox="0 0 14 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 7L13.9282 0.25H0.0717969L7 7Z" fill="black" />
  </svg>
);

export const activeDropdownCaret = (
  <svg
    width="14"
    height="7"
    viewBox="0 0 14 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 7L13.9282 0.25H0.0717969L7 7Z" fill="white" />
  </svg>
);